import { render, staticRenderFns } from "./batchImport.vue?vue&type=template&id=27e7855f&scoped=true"
import script from "./batchImport.vue?vue&type=script&lang=js"
export * from "./batchImport.vue?vue&type=script&lang=js"
import style0 from "./batchImport.vue?vue&type=style&index=0&id=27e7855f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e7855f",
  null
  
)

export default component.exports